// extracted by mini-css-extract-plugin
module.exports = {"error":"ChangeLog_error__aVlsQ","changeLog":"ChangeLog_changeLog___R1oj"};